<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="MES工序实时监测 right_12"></chart-title>
    <div class="right_12_card">
      <date-change-card
        height="70%"
        @leftClick="leftClick"
        @rightClick="rightClick"
      >
        <div id="right_12" slot="main"></div>
      </date-change-card>
      <div class="steps">
        <div
          :class="`steps_item ${step == 1 ? ' steps_active' : ''}`"
          @click="changeStep(1)"
        >
          <div class="step__head">
            <div class="step__line">
              <i class="step__line-inner"></i>
            </div>
            <div class="step__icon iconfont icon-lingxing"></div>
          </div>
          <div class="step__main">
            <div class="step__title">柜体1线</div>
          </div>
        </div>
        <div
          :class="`steps_item ${step == 2 ? ' steps_active' : ''}`"
          @click="changeStep(2)"
        >
          <div class="step__head">
            <div class="step__line">
              <i class="step__line-inner"></i>
            </div>
            <div class="step__icon iconfont icon-lingxing"></div>
          </div>
          <div class="step__main">
            <div class="step__title">柜体2线</div>
          </div>
        </div>
        <div
          :class="`steps_item ${step == 3 ? ' steps_active' : ''}`"
          @click="changeStep(3)"
        >
          <div class="step__head">
            <div class="step__icon iconfont icon-lingxing"></div>
          </div>
          <div class="step__main">
            <div class="step__title">高定线</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "right_12",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      step: 1,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    changeStep(val) {
      this.step = val;
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_12"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "12%",
          right: "12%",
          top: "13%",
          bottom: "16%",
          containLabel: true,
        },
        legend: {
          data: ["计划完成量", "实际完成量"],
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        xAxis: [
          {
            type: "category",
            data: [
              "下料",
              "拉槽",
              "封边",
              "打眼",
              "分板",
              "造型",
              "颜色",
              "打包",
            ],
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#909399",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            interval: 50,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "计划完成量",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(21,157,255,0.1)" },
                { offset: 1, color: "rgba(21,157,255,1)" },
              ]),
            },
            data: [
              4.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 23.2, 25.6, 76.7, 135.6,
            ],
          },
          {
            name: "实际完成量",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(34,228,255,0.1)" },
                { offset: 1, color: "rgba(34,228,255,1)" },
              ]),
            },
            data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 2.6, 5.9, 9.0, 26.4],
          },
        ],
      });
    },
    //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 50vh;
  .right_12_card {
    height: calc(100% - 30px);
    #right_12 {
      height: 100%;
      margin-bottom: 20px;
    }
    .steps {
      margin-top: 26px;
      display: flex;
      justify-content: center;
      .steps_item {
        cursor: pointer;
        display: inline-block;
        flex-basis: 25%;
        margin-right: 0px;
        max-width: 25%;
        .step__head {
          color: #409eff;
          border-color: #409eff;
          text-align: center;
          position: relative;
          width: 100%;
          .step__line {
            left: 50%;
            right: -50%;
            height: 2px;
            top: 11px;
            position: absolute;
            .step__line-inner {
              border-width: 1px;
              width: 100%;
              display: block;
              border-style: solid;
              color: #409eff;
            }
          }
          .step__icon {
            position: relative;
            z-index: 1;
            display: inline-flex;
            -webkit-box-align: center;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            font-size: 32px;
          }
        }
        .step__main {
          text-align: center;
          white-space: normal;
          .step__title {
            color: #409eff;
            font-size: 14px;
            line-height: 38px;
          }
        }
      }
      .steps_active {
        .step__head {
          color: #3bffd0;
          border-color: #3bffd0;
        }
        .step__main {
          .step__title {
            color: #3bffd0;
          }
        }
      }
    }
  }
}
</style>
